import RobotImage from "@/assets/images/robot.png";
import { Button } from "@/components/ui/button";

const ErrorPage = (): JSX.Element => {
  const handleTryAgain = (): void => {
    window.location.reload();
  };

  return (
    <div className='flex items-center justify-center min-h-screen bg-gray-100'>
      <div className='text-center'>
        <img src={RobotImage} className='mx-auto h-5/6' />
        <h1 className='mt-6 mb-4 text-4xl font-medium text-gray-800'>
          500 - Server Error
        </h1>
        <p className='mb-8 text-lg text-gray-600'>
          Oops! Something went wrong on our end. <br /> Wait a moment and try
          again.
        </p>
        <Button onClick={handleTryAgain}>Try Again</Button>
        <Button asChild variant={"light"} className='ml-5'>
          <a
            href='https://forms.gle/zidkpNCAiUZRGCxH7'
            target='_blank'
            rel='noreferrer'
          >
            Contact Support
          </a>
        </Button>
      </div>
    </div>
  );
};

export default ErrorPage;
